module.exports = __webpack_public_path__ + "static/media/portfolio1 (15).d9ab9028.jpeg";